import { render, staticRenderFns } from "./SuperQueryModal.vue?vue&type=template&id=12b5b722&scoped=true"
import script from "./SuperQueryModal.vue?vue&type=script&lang=js"
export * from "./SuperQueryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b5b722",
  null
  
)

export default component.exports